// extracted by mini-css-extract-plugin
export default {"main_container":"styles_main_container__4SeUx","navbar":"styles_navbar__4HaFG","btn_white":"styles_btn_white__2pHUi"};